"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectSendStatus = exports.default = void 0;

var _botframeworkWebchatCore = require("botframework-webchat-core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../../../connectToWebChat"));

var _ScreenReaderText = _interopRequireDefault(require("../../../ScreenReaderText"));

var _SendFailedRetry = _interopRequireDefault(require("./SendFailedRetry"));

var _useFocusSendBox = _interopRequireDefault(require("../../../hooks/useFocusSendBox"));

var _useLocalizer = _interopRequireDefault(require("../../../hooks/useLocalizer"));

var _usePostActivity = _interopRequireDefault(require("../../../hooks/usePostActivity"));

var _useStyleSet3 = _interopRequireDefault(require("../../../hooks/useStyleSet"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var _Constants$ActivityCl = _botframeworkWebchatCore.Constants.ActivityClientState,
    SEND_FAILED = _Constants$ActivityCl.SEND_FAILED,
    SENDING = _Constants$ActivityCl.SENDING;

var connectSendStatus = function connectSendStatus() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref, _ref2) {
    var focusSendBox = _ref.focusSendBox,
        language = _ref.language,
        postActivity = _ref.postActivity;
    var activity = _ref2.activity;
    return {
      language: language,
      retrySend: function retrySend(evt) {
        evt.preventDefault();
        postActivity(activity); // After clicking on "retry", the button will be removed from the DOM and focus will be lost (back to document.body)
        // This ensures that focus will stay within Web Chat

        focusSendBox();
      }
    };
  }].concat(selectors));
};

exports.connectSendStatus = connectSendStatus;

var SendStatus = function SendStatus(_ref3) {
  var activity = _ref3.activity,
      sendState = _ref3.sendState;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      sendStatusStyleSet = _useStyleSet2[0].sendStatus;

  var focusSendBox = (0, _useFocusSendBox.default)();
  var localize = (0, _useLocalizer.default)();
  var postActivity = (0, _usePostActivity.default)();
  var sendingText = localize('ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING');
  var label = localize('ACTIVITY_STATUS_SEND_STATUS_ALT', sendingText);
  var handleRetryClick = (0, _react.useCallback)(function () {
    postActivity(activity); // After clicking on "retry", the button will be gone and focus will be lost (back to document.body)
    // We want to make sure the user stay inside Web Chat

    focusSendBox();
  }, [activity, focusSendBox, postActivity]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ScreenReaderText.default, {
    text: label
  }), _react.default.createElement("span", {
    "aria-hidden": true,
    className: sendStatusStyleSet
  }, sendState === SENDING ? sendingText : sendState === SEND_FAILED ? _react.default.createElement(_SendFailedRetry.default, {
    onRetryClick: handleRetryClick
  }) : false));
};

SendStatus.propTypes = {
  activity: _propTypes.default.shape({
    channelData: _propTypes.default.shape({
      clientTimestamp: _propTypes.default.string,
      state: _propTypes.default.string
    })
  }).isRequired,
  sendState: _propTypes.default.oneOf([SENDING, SEND_FAILED]).isRequired
};
var _default = SendStatus;
exports.default = _default;